export default {
  badge: 'Rozet',
  open: 'Aç',
  close: 'Kapat',
  dismiss: 'Kapat',
  confirmEdit: {
    ok: 'Tamam',
    cancel: 'İptal',
  },
  dataIterator: {
    noResultsText: 'Eşleşen veri bulunamadı',
    loadingText: 'Yükleniyor... Lütfen bekleyin.',
  },
  dataTable: {
    itemsPerPageText: 'Sayfa başına satır:',
    ariaLabel: {
      sortDescending: 'Z den A ya sıralı.',
      sortAscending: 'A dan Z ye sıralı.',
      sortNone: 'Sıralı değil. ',
      activateNone: 'Sıralamayı kaldırmak için etkinleştir.',
      activateDescending: 'Z den A ya sıralamak için etkinleştir.',
      activateAscending: 'A dan Z ye sıralamak için etkinleştir.',
      selectRow: 'Satırı seç',
      selectAll: 'Tümünü seç',
      selectGroup: 'Grubu seç',
    },
    sortBy: 'Sırala',
  },
  dataFooter: {
    itemsPerPageText: 'Sayfa başına satır:',
    itemsPerPageAll: 'Hepsi',
    nextPage: 'Sonraki sayfa',
    prevPage: 'Önceki sayfa',
    firstPage: 'İlk sayfa',
    lastPage: 'Son sayfa',
    pageText: '{0} - {1} arası, Toplam: {2} kayıt',
  },
  dateRangeInput: {
    divider: 'ile',
  },
  monthPicker: {
    title: 'Ay seçin',
    itemsSelected: '{0} seçildi',
    header: 'Ay girin',
    range: {
      title: 'Ayları girin',
    },
    ariaLabel: {
      previousYear: 'Önceki yıl',
      nextYear: 'Sonraki yıl',
      selectYear: 'Yıl seçin',
      currentMonth: 'Bu ay, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} seçildi',
    range: {
      title: 'Tarihleri seçin',
      header: 'Tarihleri girin',
    },
    title: 'Tarih seçin',
    header: 'Tarih girin',
    input: {
      placeholder: 'Tarih girin',
    },
    ariaLabel: {
      previousMonth: 'Önceki ay',
      nextMonth: 'Sonraki ay',
      selectYear: 'Yıl seçin',
      previousYear: 'Önceki yıl',
      nextYear: 'Sonraki yıl',
      selectMonth: 'Ay seçin',
      selectDate: '{0}',
      currentDate: 'Bugün, {0}',
    },
  },
  noDataText: 'Bu görünümde veri yok.',
  carousel: {
    prev: 'Önceki görsel',
    next: 'Sonraki görsel',
    ariaLabel: {
      delimiter: 'Galeri sayfa {0} / {1}',
    },
  },
  calendar: {
    moreEvents: '{0} tane daha',
    today: 'Bugün',
  },
  heatmap: {
    less: 'Az',
    more: 'Çok',
  },
  input: {
    clear: '{0} temizle',
    prependAction: '{0} ön işlem',
    appendAction: '{0} ek işlem',
    otp: 'Lütfen OTP karakterini girin {0}',
  },
  fileInput: {
    counter: '{0} dosya',
    counterSize: '{0} dosya (toplamda {1})',
  },
  fileUpload: {
    title: 'Dosyaları buraya sürükleyip bırakın',
    divider: 'veya',
    browse: 'Dosyalara göz at',
  },
  timePicker: {
    am: 'ÖÖ',
    pm: 'ÖS',
    title: 'Saat seçin',
    hour: 'Saat',
    minute: 'Dakika',
    second: 'Saniye',
    notAllowed: 'Değere izin verilmiyor',
  },
  pagination: {
    ariaLabel: {
      root: 'Sayfalandırma Navigasyonu',
      next: 'Sonraki sayfa',
      previous: 'Önceki sayfa',
      page: 'Sayfaya git {0}',
      currentPage: 'Geçerli Sayfa, Sayfa {0}',
      first: 'İlk sayfa',
      last: 'Son sayfa',
    },
  },
  stepper: {
    next: 'İleri',
    prev: 'Geri',
  },
  rating: {
    ariaLabel: {
      item: '{1} üzerinden {0} puan',
    },
  },
  loading: 'Yükleniyor...',
  infiniteScroll: {
    loadMore: 'Daha fazla yükle',
    empty: 'Daha fazla içerik yok',
  },
  rules: {
    required: 'Bu alan zorunludur',
    email: 'Lütfen geçerli bir e-posta adresi girin',
    number: 'Bu alan sadece sayılar içerebilir',
    integer: 'Bu alan sadece tam sayılar içerebilir',
    capital: 'Bu alan sadece büyük harfler içerebilir',
    maxLength: 'En fazla {0} karakter girmelisiniz',
    minLength: 'En az {0} karakter girmelisiniz',
    strictLength: 'Girilen alanın uzunluğu geçersiz',
    exclude: '{0} karakteri izin verilmez',
    notEmpty: 'Lütfen en az bir değer seçin',
    pattern: 'Geçersiz biçim',
  },
  command: {
    search: 'Komut yazın veya arayın...',
  },
  hotkey: {
    then: 'sonra',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Yukarı Ok',
    downArrow: 'Aşağı Ok',
    leftArrow: 'Sol Ok',
    rightArrow: 'Sağ Ok',
    backspace: 'Geri Al',
    space: 'Boşluk',
    plus: 'artı',
    shortcut: 'Klavye kısayolu: {0}',
    or: 'veya',
  },
  video: {
    play: 'Oynat',
    pause: 'Duraklat',
    seek: 'Ara',
    volume: 'Ses',
    showVolume: 'Ses kontrolünü göster',
    mute: 'Sesi kapat',
    unmute: 'Sesi aç',
    enterFullscreen: 'Tam ekran',
    exitFullscreen: 'Tam ekrandan çık',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Ekranda renk seç',
      hueSlider: 'Ton',
      alphaSlider: 'Alfa',
      redInput: 'Kırmızı',
      greenInput: 'Yeşil',
      blueInput: 'Mavi',
      alphaInput: 'Alfa',
      hueInput: 'Ton',
      saturationInput: 'Doygunluk',
      lightnessInput: 'Parlaklık',
      hexInput: 'HEX değeri',
      hexaInput: 'Alfa değerli HEX',
      changeFormat: 'Renk biçimini değiştir',
    },
  },
}
